requestAnimationFrame(() => {
  class CartNote extends HTMLElement {
    constructor() {
      super();

      themeBase.onDOMContentLoadedTrigger(() => {
        this.addEventListener('change', debounce((event) => {
          const body = JSON.stringify({
            note: event.target.value
          });
          fetch(`${routes.cart_update_url}`, {
            ...fetchConfig(),
            ...{
              body
            }
          });
        }, 300));
      });
    }
  }

  customElements.define('cart-note', CartNote);

  themeBase.onDOMContentLoadedTrigger(function() {
    function isIE() {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf('MSIE ');
      const trident = ua.indexOf('Trident/');

      return (msie > 0 || trident > 0);
    }

    if (!isIE()) return;
    const cartSubmitInput = document.createElement('input');
    cartSubmitInput.setAttribute('name', 'checkout');
    cartSubmitInput.setAttribute('type', 'hidden');
    document.querySelector('#cart').appendChild(cartSubmitInput);
    document.querySelector('#checkout').addEventListener('click', function(event) {
      document.querySelector('#cart').submit();
    });
  });
});